import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import api from '../api/marksEntry';
import loginapi from '../api/login';


import StudentCard from "../components/RegistrationCard";
import SetIssueDate from "../components/SetIssueDate";
import DeleteSelectedEntriesModal from "../components/DeleteSelectedEntriesModal";


import { APISERVERURL } from '../APIServerURL';

function ViewnPrint({accessToken,setAccessToken,setRefreshFailed  }) {
  const navigate = useNavigate();
  const [sessions,setSessions]=useState([]);
const [isAppLoaded,setIsAppLoaded]=useState(true);
  const [selectedSession, setSelectedSession] = useState("");
const [institutes,setInstitutes]=useState([]);
const [selectedInstitute,setSelectedInstitute]=useState("");
const [programs,setPrograms]=useState([]);
const [selectedProgram,setSelectedProgram]=useState("");

const [students,setStudents]=useState([]);

const [isInstituteLoading,setIsInstituteLoading]=useState(false);
const [isStudentLoading,setIsStudentLoading]=useState(false);

const [isIssuDateLoading,setIsIssuDateLoading]=useState(false);

  const [showSetIssueDateModal, setShowSetIssueDateModal] = useState(false);
   const [showDeleteListedEntriesModal, setShowDeleteListedEntriesModal] = useState(false);

  const [selectedIssueDate,setSelectedIssueDate]=useState('');
  const [isDownloadAllBusy,setIsDownloadAllBusy]=useState(false);
    const proceedToSetAllIssueDate = () => {
     // alert('k');
  setShowSetIssueDateModal(true);
  };

const proceedToDeleteEntries = () => {
     // alert('k');
  setShowDeleteListedEntriesModal(true);
  };
  
   const sessionChanged = async (e) => {
    const session = e.target.value;
    setSelectedSession(session);

    // Reset dependent states
    setInstitutes([]);
    setSelectedInstitute("");
    setPrograms([]);
    setSelectedProgram("");
    setStudents([]);
   
    if (session) {
       setIsInstituteLoading(true);
       try{ 
        //alert(session);      
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await api.post('/getAllInstitutes',{session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.result));
        setInstitutes(response.data.result);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(true)
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await api.post('/getAllInstitutes',{session},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data.result));
               setInstitutes(response.data.result);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsInstituteLoading(false);
              //alert('app loaded'+accessToken);
            }
    }
  };

  const instituteChanged=async(e)=>{
 const institute = e.target.value;
    setSelectedInstitute(institute);

    setPrograms([]);
    setSelectedProgram("");
    setStudents([]);

    if (institute && selectedSession) {
       try{ 
        //alert(session);      
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await api.post('/getAllPrograms',{session:selectedSession,institute},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.result));
        setPrograms(response.data.result);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(true)
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await api.post('/getAllPrograms',{session:selectedSession,institute},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data.result));
               setPrograms(response.data.result);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
  }
 const programChanged=async(e)=>{
 const program = e.target.value;
    setSelectedProgram(program);

    setStudents([]);

    if (program && selectedInstitute && selectedSession) {
      setIsStudentLoading(true);
       try{ 
        //alert(session);      
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await api.post('/getAllStudents',{session:selectedSession,institute:selectedInstitute,program},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.result));
        setStudents(response.data.result);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(true)
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await api.post('/getAllStudents',{session:selectedSession,institute:selectedInstitute,program},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data.result));
               setStudents(response.data.result);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
                setIsStudentLoading(false);
              //alert('app loaded'+accessToken);
            }
    }
  }

   useEffect(()=>{
    const fetchAT=async ()=>{
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await api.post('/getAllSessions',{},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data));
        setSessions(response.data.result);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(true)
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await api.post('/getAllSessions',{},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data));
               setSessions(response.data.result);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[]);
  const handleGoBack = () => {
    navigate(`/`); 
  };

const updateLocalField = (id, field, value) => {
    setStudents(prev =>
      prev.map(student =>
        student._id === id ? { ...student, [field]: value } : student
      )
    );
  };

  const saveToBackend = async (id, field, value) => {
    try{ 
        //alert(session);      
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await api.post('/saveRegistrationField',{id, field, value},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.result));
       // setInstitutes(response.data.result);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(true)
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await api.post('/saveRegistrationField',{id, field, value},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data.result));
               //setInstitutes(response.data.result);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsInstituteLoading(false);
              //alert('app loaded'+accessToken);
            }
  };
  
const handleSetAllIssueDate = async () => {
  
    try{ 
      setIsIssuDateLoading(true);
        //alert(session);      
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await api.post('/setAllIssueDate',{selectedSession,selectedInstitute,selectedProgram,selectedIssueDate},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.result));
      setStudents(response.data.result);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(true)
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await api.post('/setAllIssueDate',{selectedSession,selectedInstitute,selectedProgram,selectedIssueDate},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data.result));
               setStudents(response.data.result);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsIssuDateLoading(false);
              setShowSetIssueDateModal(false);
              //setIsInstituteLoading(false);
              //alert('app loaded'+accessToken);
            }
  };
  const handleDeleteSelectedEntries = async () => {
  
    try{ 
      //setIsIssuDateLoading(true);
        //alert(session);      
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        //session,institute,program
        const response=await api.post('/handleDeleteSelectedEntries',{session:selectedSession,institute:selectedInstitute,program:selectedProgram},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.result));
      setStudents([]);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(true)
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await api.post('/handleDeleteSelectedEntries',{session:selectedSession,institute:selectedInstitute,program:selectedProgram},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data.result));
               setStudents([]);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsIssuDateLoading(false);
              setShowDeleteListedEntriesModal(false);
              //setIsInstituteLoading(false);
              //alert('app loaded'+accessToken);
            }
  };

  const handleFieldChange = (id, field, value) => {
    updateLocalField(id, field, value);
  };

  const handleFieldBlur = (id, field, value) => {
    saveToBackend(id, field, value);
  };


  function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            //setIsloading(false);
        });
      });
    }
  
async function downloadAllGradeCards(e,bg)
    {
      setIsDownloadAllBusy(true);
      try{
        const response= await api.post('/downloadAllRegistrationCards',{selectedSession,selectedInstitute,selectedProgram,bg},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await api.post('/downloadAllRegistrationCards',{selectedSession,selectedInstitute,selectedProgram,bg},{headers:{'Authorization':`Bearer ${nat}`}});    
            alert(response.data);
            downloadFile(response.data);
           }
           catch(err)
           {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
      finally
      {
            setIsDownloadAllBusy(false);
      }
    }

  async function downloadSingleGradeCard(_id,regno,bg="YES")
    {
      
      try{
        const response= await api.post('/downloadSingleRegistrationCard',{_id,regno,bg},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await api.post('/downloadSingleRegistrationCard',{_id,regno,bg},{headers:{'Authorization':`Bearer ${nat}`}});    
            alert(response.data);
            downloadFile(response.data);
           }
           catch(err)
           {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
    }

  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> VIEW & PRINT REG-CERTIFICATES</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(...)</p>    
          </div>

    

      {isAppLoaded&&(<div className="flex flex-col justify-center items-center gap-4 mt-4 w-full ">
        <div className="flex flex-col items-center justify-center w-full max-w-[600px] w-[99%] ">
          <label className="mb-2 w-full text-left">Select Session</label>
      <select
        value={selectedSession}
        onChange={(e) => sessionChanged(e)}
        className="p-2 rounded border w-full"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
        </div>


         <div className="flex flex-col items-center justify-center w-full max-w-[600px] w-[99%] ">
          <label className="mb-2 w-full text-left">Select Institute</label>
      {isInstituteLoading && (<select
       
        className="p-2 rounded border w-full"
      >
        <option value="">-- Please wait --</option>
       
      </select>)}
      
      {!isInstituteLoading &&(<select
        value={selectedInstitute}
        onChange={(e) => instituteChanged(e)}
        className="p-2 rounded border w-full"
      >
        <option value="">-- Choose an Institute --</option>
        {institutes.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>)}
        </div>
        
 <div className="flex flex-col items-center justify-center w-full max-w-[600px] w-[99%] ">
         <label className="mb-2 w-full text-left">Select Programme</label>
  <select
    value={selectedProgram}
    onChange={(e) => programChanged(e)}
    className="p-2 rounded border w-full"
  >
    <option value="">-- Choose a programme --</option>
    {programs.map((prog, index) => (
      <option key={index} value={prog.upload_id}>
        {prog.programme_name}
      </option>
    ))}
  </select>
        </div>
        
<div className="w-full flex flex-col justify-center items-center gap-1">
      {isStudentLoading ? (
    <p className="text-center">Please wait...</p>
  ) : (
    <>
      {students.length > 0 ? (
        <div className="w-full flex flex-col justify-center items-center gap-1">
          <div className="w-full flex flex-wrap justify-center items-center p-2 bg-blue-100 gap-2">
            <button  onClick={proceedToDeleteEntries} className="bg-yellow-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-yellow-600 transition duration-300 text-xs">
              DELETE LISTED ENTRIES
            </button>


            <button  onClick={proceedToSetAllIssueDate} className="bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              SET ISSUE DATE
            </button>

                <button  
  onClick={(e) => downloadAllGradeCards(e, "YES")}
  disabled={isDownloadAllBusy}
  className={`px-4 py-2 rounded-lg shadow-md text-xs transition duration-300 ${
    isDownloadAllBusy 
      ? 'bg-gray-400 text-white cursor-not-allowed' 
      : 'bg-green-500 text-white hover:bg-green-600'
  }`}
>
  {isDownloadAllBusy ? 'Please wait...' : 'DOWNLOAD ALL'}
</button>
          </div>
          <div className="w-full flex flex-wrap justify-center items-center  bg-blue-100 gap-2">
            <SetIssueDate
              isOpen={showSetIssueDateModal}
              onCancel={() => setShowSetIssueDateModal(false)}
              onConfirm={() => {
                //setShowSetIssueDateModal(false);
                //call the actual delete function
                handleSetAllIssueDate();                
              }}
             selectedIssueDate={selectedIssueDate}
             setSelectedIssueDate={setSelectedIssueDate}
                 /> 
          </div>
          <div className="w-full flex flex-wrap justify-center items-center  bg-blue-100 gap-2">
            <DeleteSelectedEntriesModal
              isOpen={showDeleteListedEntriesModal}
              onCancel={() => setShowDeleteListedEntriesModal(false)}
              onConfirm={() => {
                //setShowSetIssueDateModal(false);
                //call the actual delete function
                handleDeleteSelectedEntries();                
              }}
                 /> 
          </div>
        {!isIssuDateLoading && students.map((student, index) => (
          <StudentCard
            key={student._id || index}
            student={student}
            index={index}
            onChange={handleFieldChange}
            onBlur={handleFieldBlur}
            downloadSingleGradeCard={downloadSingleGradeCard}
          />
        ))}
        {isIssuDateLoading && (<p className="text-center"> Please Wait.....</p>)}
        </div>
      ) : (
        <p className="text-center">Nothing to display</p>
      )}
    </>
  )}
    </div>


      </div>)}
       {!isAppLoaded && (<p className="w-full text-center">Please Wait....</p>)}
      </div>
    </main>
  );
}

export default ViewnPrint;
